import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { translations } from '../../../../locales/translations';
import { biType } from '../../../../locales/types';
import {
  selectAllPreviousRecurring,
  selectContractInfoView,
  selectPreviousRecurring,
} from '../slice/selectors';
import { RecurringData } from '../slice/types';
import { QuoteItemCard } from './QuoteItemCard';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export function PreviousRecurringTab() {
  const { t } = useTranslation();
  const previousRecurringData: RecurringData | undefined = useSelector(selectPreviousRecurring);
  const allPreviousRecurringData = useSelector(selectAllPreviousRecurring);
  const contractInfoView = useSelector(selectContractInfoView);
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if ((allPreviousRecurringData?.length ?? 0) > 0) {
    return (
      <div>
        <h4>{t(translations.contractDetail.previousRecurring)}</h4>
        <AppBar position="static">
          <Tabs style={{ backgroundColor: 'black' }} value={value} onChange={handleChange}>
            {
              allPreviousRecurringData.map((item) => {
                return <Tab label={item.contractNo} key={item.index} {...a11yProps(item.index)} />;
              })
            }
          </Tabs>
        </AppBar>
        {
          allPreviousRecurringData.map((item) => {
            return (
              <TabPanel value={value} index={item.index} key={item.index}>
                <div className='recurring-item-container'>
                  {(item.detail?.recurringItems ?? []).map((item, index) => (
                    <QuoteItemCard
                      key={index}
                      data={item}
                      viewChangeData={null}
                      displayType={biType.RECURRING}
                    />
                  ))}
                </div>
              </TabPanel>
            );
          })
        }
      </div>
    );
  }

  if (previousRecurringData) {
    return (
      <div className='recurring-item-container'>
        <h4>{t(translations.contractDetail.previousRecurring)}</h4>
        <Tabs style={{ backgroundColor: 'black' }} value={value} onChange={handleChange}>
          <Tab label={contractInfoView?.renewedFromContract} {...a11yProps(0)} />
        </Tabs>
        {(previousRecurringData.recurringItems ?? []).map((item, index) => (
          <QuoteItemCard
            key={index}
            data={item}
            viewChangeData={null}
            displayType={biType.RECURRING}
          />
        ))}
      </div>
    );
  }

  return <></>;
}
